import { COLOR } from "@fixel/fixel-components/dist/components/shared/styleTokens";
import styled, { css } from "styled-components/macro";
import { device } from "../../device";

export const StyledTwoBoxWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	padding: 1rem 0 2.2rem 0;
`;

export const StyledTitle = styled.h1`
	font-weight: 600;
	font-size: 1.2rem;
	line-height: 1.5rem;
	color: #272b2f;
`;

export const StyledTitleBold = styled.h1`
	font-size: 32px;
	line-height: 48px;
	margin-bottom: 1.6rem;
	font-weight: 600;
`;

export const StyledPurchaseDetails = styled.div`
	background: #ffffff;
	margin: auto;
	width: 330px;
	padding: 2rem 45px;
	border-radius: 4px;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	h4 {
		margin-bottom: 10px;
		font-weight: bold;
		font-size: 18px;
	}
`;

export const StyledLinkButton = styled.button`
	border: none;
	background: transparent;
	color: #6270c6;
	cursor: pointer;
	&:focus {
		outline: 0;
	}
`;

export const ErrorContainer = styled.div`
	background-color: #f8d7da;
	border: 1px solid #721c24;
	position: relative;
	overflow: hidden;
	display: flex;
	justify-content: space-between;
	align-items: center;
	text-align: left;
	padding: 24px;
	width: 100%;
	border-radius: 8px;
	height: 100%;
`;

export const SuccessContainer = styled.div`
	padding: 0.6rem 0;
	background: #4bb543;
	width: 100%;
	color: #ffffff;
	text-align: center;
	margin-top: 1rem;
`;

export const OrDivider = styled.div`
	color: #acb8b9;
	font-size: 12px;
	width: 100%;
	text-align: center;
	margin: 2rem 0;
	:before {
		content: "";
		width: calc(50% - 14px);
		height: 1px;
		background-color: #acb8b9;
		display: inline-block;
		margin-bottom: 3px;
		margin-right: 5px;
	}
	:after {
		content: "";
		width: calc(50% - 14px);
		height: 1px;
		background-color: #acb8b9;
		display: inline-block;
		margin-bottom: 3px;
		margin-left: 5px;
	}
`;

export const ActionRow = styled.div`
	margin-top: 0.5rem;
	font-weight: 400;
	font-size: 12px;
	color: #acb8b9;
	display: flex;
	align-items: center;
	a {
		color: #3a5558;
		font-weight: 600;
		margin-left: auto;
		pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
	}
`;

export const StyledButton = styled.button`
	border-radius: 5px;
	padding: 8px 12px;
	border: none;
	cursor: pointer;
	width: 100%;
	min-height: 42px;
`;

export const Container = styled.div`
	width: 100vw;
	height: 100vh;
	margin: auto;
	text-align: center;
	place-items: center;
	display: grid;
`;

export const StyledTitle24 = styled.h1`
	margin-top: 0;
	font-size: 24px;
	line-height: 36px;
	font-weight: 600;
	color: ${COLOR.black};
	text-align: left;
`;
export const StyledInnerPage = styled.div`
	display: flex;
	flex-direction: column;
	place-items: left center;
	padding: 1rem 2rem;
	@media ${device.mobileL} {
		padding: 0;
		overflow-x: auto;
	}
`;
export const StyledFormFlexRow = styled.form`
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
	flex-wrap: wrap-reverse;
`;
export const StyledLabel = styled.label`
	font-size: 12px;
	line-height: 18px;

	color: ${COLOR.black};
	opacity: 0.7;
`;
export const StyledLabelLarge = styled(StyledLabel)`
	font-size: 14px;
	line-height: 21px;
	color: #3a5558;
	opacity: 1;
	padding-bottom: 0.3rem;
`;
export const StyledInput = styled.input`
	background: ${COLOR.white};
	border: 1px solid ${COLOR.greyLight2};
	border-radius: 4px;
	font-size: 14px;
	line-height: 100%;
	color: ${COLOR.black};
	padding: 0.5rem;
	${({ disabled }) =>
		disabled &&
		css`
			background: #f4f6f8;
			border: 1px solid #acb8b9;
		`}
	width: ${({ width }) =>
		css`
			${width ? width : "auto"}
		`}
`;
export const StyledGreyInput = styled(StyledInput)`
	background: #f4f6f8;
	border: 1px solid #acb8b9;
	width: 100%;
`;

export const StyledInputContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: start;
	text-align: left;
`;
export const StyledInputContainerInline = styled(StyledInputContainer)`
	width: max-content;
	display: flex;
	flex-direction: column;
	align-items: start;
	text-align: left;
`;
export const FlexColumn = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: start;
	gap: 0.2rem;
`;
export const FlexRow = styled.div`
	display: flex;
	gap: 1rem;
	@media ${device.mobileL} {
		flex-wrap: wrap;
	}
`;
export const StyledGoBack = styled.button`
	&:hover {
		cursor: pointer;
	}
	display: flex;
	align-items: center;
	color: rgb(87, 94, 104, 0.5);
	font-size: 16px;
	line-height: 22px;
	pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};

	svg {
		margin: 8px;
	}
`;
export const StyledInBoxFrame = styled.div`
	width: 100%;
	padding: 1.2rem;
	background: #ffffff;
	border: 1px solid #ebedee;
	box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
	border-radius: 8px;
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;
export const StyledInBoxFrameHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	cursor: pointer;
	h3 {
		font-weight: 500;
		display: flex;
		gap: 0.7rem;
		align-items: center;
		font-size: 16px;
		line-height: 24px;
		color: #3a5558;
	}
`;
export const StyledInBoxFrameContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	padding-top: 1rem;
	p {
		font-weight: 500;
		font-size: 14px;
		line-height: 21px;
		color: #3a5558;
	}
`;
export const StyledSmallError = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	gap: 4px;
	padding: 8px;
	background: rgba(239, 83, 80, 0.1);
	border-radius: 4px;
	font-weight: 500;
	font-size: 10px;
	line-height: 15px;
	color: #ef5350;
`;
